export default "__VITE_ASSET__BVraomXe__"